import React__default, { lazy, useState, useMemo, useCallback, useEffect, Suspense } from 'react';
import clsx from 'clsx';
import { debounce } from 'lodash-es';
import { cssTextarea } from './TextInputV2.css.js';

const Label = lazy(() => import('../label/Label.js').then((module) => ({ default: module.Label })));
const TextInputV2 = ({ id, label, displaySize = null, className, onChange, required, textarea, onBlur, onFocus, delay, value, removeWrapper = false, removeLeadingZeros = false, ...inputProps }) => {
    const [stateValue, setStateValue] = useState('');
    const debounceOnChange = useMemo(() => debounce((v, e) => {
        onChange?.(v, e);
    }, delay, { leading: false, trailing: true }), [delay, onChange]);
    const onChangeInput = useCallback((e) => {
        const value = e.target.value;
        const newValue = removeLeadingZeros && value !== '' && !isNaN(Number(value)) ? Number(value).toString() : value;
        setStateValue(newValue);
        delay ? debounceOnChange(newValue, e) : onChange?.(newValue, e);
    }, [debounceOnChange, delay, onChange, removeLeadingZeros]);
    const htmlInputProps = {
        id,
        className: clsx('c-input', displaySize ? `c-input--${displaySize}` : null),
        onChange: onChangeInput,
        onBlur,
        onFocus,
        value: stateValue,
        required,
        ...inputProps
    };
    useEffect(() => {
        if (value !== undefined)
            setStateValue(value);
    }, [value]);
    useEffect(() => {
        return () => {
            debounceOnChange.cancel();
        };
    }, [debounceOnChange]);
    const content = (React__default.createElement(React__default.Fragment, null,
        !!label && (React__default.createElement(Suspense, { fallback: '' },
            React__default.createElement(Label, { htmlFor: id, required: required, "data-testid": `${id ? `${id}-label` : ''}` }, label))),
        textarea ? (React__default.createElement("textarea", { ...htmlInputProps, className: `${htmlInputProps.className} ${cssTextarea}` })) : (React__default.createElement("input", { ...htmlInputProps }))));
    if (removeWrapper)
        return content;
    return (React__default.createElement("div", { className: className, "data-testid": `${id ? `${id}-wrapper` : ''}` }, content));
};

export { TextInputV2 };
//# sourceMappingURL=TextInputV2.js.map
